module.exports = __webpack_public_path__ + "img/serifnew_box06.ad961bee.jpg";